import { GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import WorkItemLinkChildContents from '../../../../../../../app/assets/javascripts/work_items/components/shared/work_item_link_child_contents.vue?vue3';
import WorkItemStatusBadge from './work_item_status_badge.vue?vue3';
import { WIDGET_TYPE_STATUS, METADATA_KEYS } from '~/work_items/constants';
import { getMetadataWidgetsFromWorkItem } from '../../../../../../../app/assets/javascripts/work_items/utils.js?vue3';
export default {
    name: 'WorkItemLinkChildContentsEE',
    components: {
        WorkItemLinkChildContents,
        WorkItemStatusBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        childItem: {
            type: Object,
            required: true
        },
        canUpdate: {
            type: Boolean,
            required: true
        },
        isGroup: {
            type: Boolean,
            required: false,
            default: false
        },
        workItemFullPath: {
            type: String,
            required: true
        },
        hiddenMetadataKeys: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        contextualViewEnabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'click',
        'mouseout',
        'mouseover',
        'remove-child'
    ],
    computed: {
        metadataWidgets () {
            return getMetadataWidgetsFromWorkItem(this.childItem);
        },
        customStatus () {
            return this.metadataWidgets[WIDGET_TYPE_STATUS]?.status;
        },
        showCustomStatus () {
            return this.customStatus && !this.hiddenMetadataKeys.includes(METADATA_KEYS.STATUS);
        }
    }
};
